<template>
<div class="nkn-roadmap">
  <div class="container">
    <div class="common-title">{{$t("about.roadmap.title")}}</div>
    <div class="roadmap-body">
      <img v-if="this.$i18n.locale === 'zh'" v-lazy="'/static/img/about/roadmap/roadmap_c_zh.png'">
      <img v-else v-lazy="'/static/img/about/roadmap/roadmap_c.png'">
    </div>
    <div class="roadmap-body">
      <img v-if="this.$i18n.locale === 'zh'" v-lazy="'/static/img/about/roadmap/roadmap_t_zh.png'">
      <img v-else v-lazy="'/static/img/about/roadmap/roadmap_t.png'">
    </div>
  </div>
</div>
</template>

<script>
import ProcessModule from '@/components/about/plugins/ProcessModule'
export default {
  components: {
    ProcessModule
  }
}
</script>

<style lang="scss" scoped>
.nkn-roadmap {
  // background: #0a163c;
  background: #fff;
  box-sizing: border-box;

  .container {
    background: inherit;
    padding: 6rem 0 0 0;

    @media screen and (max-width: 768px) {
      padding: 20px 0;
    }
  }

  .roadmap-body {
    padding-bottom: 80px; display: flex; justify-content: center;
    img { width: 100%; height: 100%; max-width: 900px; }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/about/nknRoadmap.vue